/* eslint-disable no-unused-vars */

import React, { useEffect } from 'react'


const PainPointDetails = () => {
  
  
  return (
    <div>
        <h1>Pain Point details</h1>
    </div>
  )
}

export default PainPointDetails